import { NavBar, Form, Button, Input, DatePicker, Selector, Toast } from 'antd-mobile'
import React, { useCallback, useRef, useState, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import '../index.css';
import moment from "moment";
import { gameYearApi } from '../../features/game-year/api/gameYearApi';

export default function GameYearUpdate() {
    const [buttomLoading, setButtomLoading] = useState(false)
    const location = useLocation();
    const [form] = Form.useForm();
    const datePickerRef = useRef();

    // Safer state access
    const gameYearInfo = location.state?.yearInfo;

    const updateGamefunc = (values) => {
        if (!gameYearInfo?.id) {
            Toast.show({ icon: 'fail', content: '活动ID缺失' });
            return;
        }

        const matchTime = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss');

        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        setButtomLoading(true)
        
        gameYearApi.save({
            id: gameYearInfo.id,
            gameTime: matchTime,
            gameAddress: values.gameAddress,
            teamType: 2,
            gameName: values.gameName,
            lat: gameYearInfo.lat || "30.64728",
            lng: gameYearInfo.lng || "104.0774",
            dinnerLat: gameYearInfo.dinnerLat || "30.64728",
            dinnerLng: gameYearInfo.dinnerLng || "104.0774",
            dinnerAddress: values.dinnerAddress
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '修改成功！',
                        icon: 'success',
                        afterClose: () => {
                            window.history.back()
                        },
                    })
                } else {
                    Toast.show({
                        content: response.data.msg || '修改失败',
                        icon: 'fail'
                    })
                }
            })
            .catch(function (error) {
                console.error(error);
                Toast.show({
                    content: '网络错误,请重试!',
                    icon: 'fail'
                })
            })
            .finally(() => {
                setButtomLoading(false)
            });
    }

    const minDate = new Date()
    const handleDatePickerClick = () => {
        datePickerRef.current?.open();
    };

    const renderLabel = useCallback((type, data) => {
        switch (type) {
            case 'year': return data + '年';
            case 'month': return data + '月';
            case 'day': return data + '日';
            case 'hour': return data + '时';
            case 'minute': return data + '分';
            default: return data;
        }
    }, []);

    // Pre-calculate initial values to avoid Invalid Date issues
    const initialValues = useMemo(() => {
        if (!gameYearInfo) return {};
        return {
            gameName: gameYearInfo.gameName,
            startTime: gameYearInfo.gameTime ? moment(gameYearInfo.gameTime).toDate() : new Date(),
            gameAddress: gameYearInfo.gameAddress,
            dinnerAddress: gameYearInfo.dinnerAddress
        };
    }, [gameYearInfo]);

    if (!gameYearInfo) {
        return (
            <div className="game-year-container has-unified-nav">
                <NavBar onBack={() => window.history.back()}>修改年会活动</NavBar>
                <div style={{ padding: '40px', textAlign: 'center', color: '#86909C' }}>
                    读取活动数据失败，请返回列表重新进入
                </div>
            </div>
        )
    }

    return (
        <div className="game-year-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                修改年会活动
            </NavBar>
            
            <div style={{ padding: '16px' }}>
                <Form
                    form={form}
                    name='form'
                    layout='vertical'
                    onFinish={updateGamefunc}
                    initialValues={initialValues}
                    footer={
                        <Button
                            block
                            type='submit'
                            size='large'
                            className="create-activity-btn"
                            style={{ marginTop: '20px' }}
                            loading={buttomLoading}
                        >
                            保存修改
                        </Button>
                    }
                >
                    <Form.Header>基本信息修改</Form.Header>
                    <Form.Item name='gameName' label='活动名称' rules={[{ required: true, message: '请输入活动名称' }]}>
                        <Input placeholder='例：科朋2025春节活动' />
                    </Form.Item>

                    <Form.Item
                        name='startTime'
                        label='活动日期'
                        trigger='onConfirm'
                        onClick={handleDatePickerClick}
                        rules={[{ required: true, message: '请选择活动日期' }]}
                    >
                        <DatePicker
                            min={minDate}
                            ref={datePickerRef}
                            precision='minute'
                            title='选择活动时间'
                            mode="date"
                            className="premium-date-picker"
                            renderLabel={renderLabel}
                            filter={{
                                minute: (val) => val % 5 === 0,
                            }}
                        >
                            {(value) =>
                                value ? (
                                    <div style={{ color: '#1D2129', fontWeight: '500' }}>
                                        {moment(value).format('YYYY年MM月DD日 HH:mm')}
                                    </div>
                                ) : (
                                    <span style={{ color: '#86909C' }}>请选择日期</span>
                                )
                            }
                        </DatePicker>
                    </Form.Item>

                    <Form.Header>场地信息修改</Form.Header>
                    <Form.Item
                        name='gameAddress'
                        label='活动场地'
                        rules={[{ required: true, message: '请输入或选择活动场地' }]}
                    >
                        <Input placeholder='请输入活动场地名称' />
                    </Form.Item>

                    <Form.Item label='快速选择场地' help='点击下方常用场地快速填充'>
                        <Selector
                            columns={2}
                            options={[
                                { label: '华西东区足球场', value: '四川大学华西校区东区-足球场' },
                                { label: '三分足球场', value: '高新区三分足球场' },
                            ]}
                            onChange={(arr) => {
                                if (arr.length) {
                                    form.setFieldsValue({ gameAddress: arr[0] });
                                }
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name='dinnerAddress'
                        label='晚宴地址'
                    >
                        <Input placeholder='请输入晚宴酒店或餐厅名称' />
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}
